import { render, staticRenderFns } from "./new-login.vue?vue&type=template&id=68d983c0&scoped=true&"
import script from "./new-login.vue?vue&type=script&lang=js&"
export * from "./new-login.vue?vue&type=script&lang=js&"
import style0 from "./new-login.vue?vue&type=style&index=0&id=68d983c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d983c0",
  null
  
)

export default component.exports